module.exports = __webpack_public_path__ + "static/img/23_fengxiang.908ea9d8.png";